import { useCallback } from 'react'
import { track } from '@amplitude/analytics-browser'
import TagManager from 'react-gtm-module'
import { E_AmplitudeEventName } from '@/redux/profile/profile.types'
import { useExchageType } from './useExchangeType'

export interface IAnalyticsEvent {
  event_type: E_AmplitudeEventName
  event_properties?: Record<string, any>
}

function baseTrackEvent(event: E_AmplitudeEventName | IAnalyticsEvent, defaultExchangeType: string): void {
  const amplitudeEvent: IAnalyticsEvent = typeof event === 'string' ? { event_type: event } : { ...event }

  amplitudeEvent.event_properties = amplitudeEvent.event_properties ?? {}

  if (!('exchangeType' in amplitudeEvent.event_properties)) {
    amplitudeEvent.event_properties.exchangeType = defaultExchangeType
  }

  track(amplitudeEvent)

  try {
    TagManager.dataLayer({
      dataLayer: {
        event: amplitudeEvent.event_type,
        ...amplitudeEvent.event_properties,
      },
    })
  } catch (error) {
    console.error('track error', error)
  }
}

export function useTrackEvent() {
  const { exchangeType } = useExchageType()
  return useCallback(
    (event: E_AmplitudeEventName | IAnalyticsEvent) => {
      baseTrackEvent(event, exchangeType)
    },
    [exchangeType]
  )
}
